import AddIcon from "@mui/icons-material/Add";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Collapse, IconButton } from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import { AI_MAPPING_CATEGORIES, getCategoryColor, getCategoryLabel } from "../aiMappingColors";
import { AiMappingController } from "../useAiMappingController";

export const compactActionSx = {
  minWidth: 0,
  px: 1.25,
  py: 0.5,
  fontSize: 11,
  borderRadius: "999px",
  minHeight: 30,
  lineHeight: 1.1,
};

export const taskKindLabel = (
  kind: AiMappingController["activeTask"] extends { kind: infer K } ? K : never
): string =>
  kind === "pdf" ? "Exporting PDF…" : kind === "segment" ? "Segmenting…" : "Detecting…";

export function CollapsibleSection({
  title,
  subtitle,
  open,
  onToggle,
  children,
  actions,
}: {
  title: string;
  subtitle?: string;
  open: boolean;
  onToggle: () => void;
  children: React.ReactNode;
  actions?: React.ReactNode;
}) {
  return (
    <MDBox p={1} sx={{ border: "1px solid #e7ebf0", borderRadius: "14px", bgcolor: "#fff" }}>
      <MDBox display="flex" alignItems="center" gap={1}>
        <MDBox sx={{ flex: 1, minWidth: 0, cursor: "pointer" }} onClick={onToggle}>
          <MDTypography variant="button" fontWeight="medium" sx={{ lineHeight: 1.15 }}>
            {title}
          </MDTypography>
          {subtitle && (
            <MDTypography variant="caption" color="text" display="block">
              {subtitle}
            </MDTypography>
          )}
        </MDBox>
        {actions}
        <IconButton size="small" onClick={onToggle}>
          <ExpandMoreIcon
            fontSize="small"
            sx={{
              transform: open ? "rotate(180deg)" : "none",
              transition: "transform 150ms ease",
            }}
          />
        </IconButton>
      </MDBox>
      <Collapse in={open}>
        <MDBox pt={1}>{children}</MDBox>
      </Collapse>
    </MDBox>
  );
}

export function QuickAddBanner({ controller }: { controller: AiMappingController }) {
  return (
    <MDBox
      display="flex"
      alignItems="center"
      gap={1}
      p={0.75}
      sx={{ border: "1px dashed #1e88e5", borderRadius: "8px" }}
      data-testid="ai-mapping-quick-add-banner"
    >
      <span
        style={{
          width: 10,
          height: 10,
          borderRadius: "50%",
          backgroundColor: getCategoryColor(controller.quickAddCategory ?? ""),
          flexShrink: 0,
        }}
      />
      <MDTypography variant="caption" color="text" sx={{ flex: 1 }}>
        Clicking the map adds {getCategoryLabel(controller.quickAddCategory ?? "")}.
      </MDTypography>
      <MDButton size="small" variant="text" onClick={controller.cancelQuickAdd}>
        Done
      </MDButton>
    </MDBox>
  );
}
